import getWorkerCompliance from "../../../utils/compliance/getWorkerCompliance";

export default function ComplianceWorkerCard({
  worker,
  docsApproved = 0,
  allDocsApproved = false,
  busy = "",
  onApproveAllDocs,
  onApproveWorker,
  children,
}) {
  const compliance = getWorkerCompliance(worker);

  return (
    <div
      style={{
        border: "1px solid #e2e8f0",
        borderRadius: 16,
        padding: 12,
        background: "#fff",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: 10,
        }}
      >
        <div>
          <div style={{ fontWeight: 950, color: "#0f172a" }}>
            {worker.email || worker.uid}
          </div>

          <div
            style={{
              marginTop: 4,
              color: "#64748b",
              fontWeight: 800,
              fontSize: 12,
            }}
          >
            {compliance.label} — {compliance.reason}
          </div>
        </div>

        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <button
            disabled={Boolean(busy)}
            style={{
              border: "1px solid #0f766e",
              background: "#0f766e",
              color: "#fff",
              borderRadius: 10,
              padding: "8px 12px",
              fontWeight: 900,
              fontSize: 12,
              cursor: "pointer",
            }}
            onClick={() => onApproveAllDocs?.(worker)}
          >
            Approve All Docs
          </button>

            <button
              disabled={!allDocsApproved || Boolean(busy)}
              style={{
                border: allDocsApproved
                  ? "1px solid #16a34a"
                  : "1px solid #cbd5e1",
                background: allDocsApproved ? "#16a34a" : "#cbd5e1",
                color: "#fff",
                borderRadius: 10,
                padding: "8px 12px",
                fontWeight: 900,
                fontSize: 12,
                cursor: allDocsApproved ? "pointer" : "not-allowed",
              }}
              onClick={() => onApproveWorker?.(worker)}
            >
              {allDocsApproved ? "Approve Worker" : `Approve Worker (${docsApproved}/4 documents)`}
            </button>
        </div>
      </div>

      {children}
    </div>
  );
}
